<zwi-main-wrapper>
  <zwi-main-content>
    @if (status === 1) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    <mat-toolbar>
      <div class="zwi-page-title">
        <mat-icon class="zwi-page-title__icon">check_circle</mat-icon>
        <div class="zwi-page-title__text">Following</div>
      </div>
    </mat-toolbar>
    <div class="zwi-main-content">
      @if (authService.sessionStatus() !== 2) {
      } @else {
        @if (authService.hasSession() === false) {
          <zwi-sign-in-call-to-action>
            <ng-container title>Sign in to follow ministries</ng-container>
            <ng-container content>Once you sign in, you'll be able to follow ministries.</ng-container>
          </zwi-sign-in-call-to-action>
        } @else {
          <zwi-subscriptions></zwi-subscriptions>
        }
      }
    </div>
  </zwi-main-content>
</zwi-main-wrapper>
